var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header_clearance"},[_c('HeaderMobile'),_vm._v(" "),_c('HeaderClearanceMain')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }